import { TableCell, TableRow } from '@mui/material';
import TableHead from '@mui/material/TableHead';
import { useTranslation } from 'react-i18next';

interface Column {
  id: 'time' | 'order_id' | 'restaurant_name' | 'order_detail' | 'status' | 'edit' | 'seat' | 'delivery_time' | 'multi_orders';
  label: string;
  minWidth?: number;
  format?: (value: number) => string;
  permission?: boolean;
}

const columns: Column[] = [
  { id: 'time', label: 'ORDER_DATE', minWidth: 170 },
  { id: 'order_id', label: 'ORDER_ID', minWidth: 100 },
  { id: 'restaurant_name', label: 'RESTAURANT_NAME', minWidth: 250, permission: true },
  {
    id: 'order_detail',
    label: 'ORDER_DETAIL',
    minWidth: 170,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'seat',
    label: 'SEAT_NUMBER',
    minWidth: 150,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'delivery_time',
    label: 'DELIVERY_TIME',
    minWidth: 150,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'multi_orders',
    label: 'MULTI_ORDER',
    minWidth: 70,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'status',
    label: 'STATUS',
    minWidth: 70,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'edit',
    label: '',
    minWidth: 50,
    format: (value: number) => value.toLocaleString('en-US'),
  },
];

function TableHeadCustom({ style, showForSuperAdmin }: { style: string; showForSuperAdmin: boolean }) {
  const { t } = useTranslation();
  return (
    <TableHead className={style}>
      <TableRow>
        {columns
          .filter((column) => !column.permission || (column.permission && showForSuperAdmin))
          .map((column) => (
            <TableCell key={column.id} style={{ minWidth: column.minWidth, borderBottom: '1px solid #e0e0e0', borderRight: '1px solid #e0e0e0', padding: '8px' }}>
              {t(`${column.label}`)}
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}

export default TableHeadCustom;
